import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=1c2d5821"
import script from "./infoDetail.vue?vue&type=script&lang=js"
export * from "./infoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports